var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iftttNotice_option_left"},[_c('span',{staticClass:"iftttNotice_option_left_num"},[_vm._v(_vm._s(_vm.num))]),_c('span',{staticClass:"iftttNotice_option_left_label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }